module.exports = __webpack_public_path__ + "static/card-winalot-review-new2-6b07d3c2d1e45e92e40dcf2e88f858ba.png";